import { Button, Link, Stack, Typography } from '@mui/material';
import { DICTIONARY } from 'Enum';
import { Dictionary } from 'Dictionary';
import { useNavigate } from 'react-router-dom';
import { RoutesConfig } from 'Routes';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ContactUs } from 'Components/ContactUs';
import { useState } from 'react';

interface IFormAutoSaveTypography {
  save: () => Promise<void>;
}

export const FormAutoSaveTypography = (props: IFormAutoSaveTypography) => {
  const [showContactUsModal, setShowContactUsModal] = useState<boolean>(false);

  const isDesktop = useIsDesktop();
  const buttonSx = isDesktop ? { minWidth: '225px !important' } : {};
  const navigate = useNavigate();

  const dictionary = useDictionary(Dictionary, DICTIONARY.GENERAL);

  const returnToTheMainLink = async () => {
    await props.save();
    navigate(RoutesConfig.STATUS_LOBBY.PATH);
  };

  return (
    <>
      <Stack justifyContent='center' alignItems='center' gap='48px' m='48px 0'>
        <Stack alignItems='center'>
          <Typography>{dictionary.formHelp}</Typography>
          <Link
            sx={{
              cursor: 'pointer',
            }}
            onClick={() => setShowContactUsModal(true)}
          >
            {dictionary.happyToHelp}
          </Link>
        </Stack>
        <Stack
          direction={isDesktop ? 'row' : 'column'}
          justifyContent='center'
          alignItems={isDesktop ? 'center' : undefined}
          gap={isDesktop ? '32px' : '16px'}
          maxWidth={isDesktop ? undefined : '226px'}
        >
          <Button
            sx={buttonSx}
            variant='outlined'
            onClick={returnToTheMainLink}
          >
            {dictionary.goBackToTheMainScreen}
          </Button>
          <Button sx={buttonSx} variant='contained' type='submit'>
            {dictionary.finishStep}
          </Button>
        </Stack>
      </Stack>
      <ContactUs
        isVisible={showContactUsModal}
        closeModal={() => setShowContactUsModal(false)}
      />
    </>
  );
};
